import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { undoActions } from '@state/undo';

// Typing keeps its own undo: text fields, the rich-text editor and anything editable.
const isTyping = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  (target.isContentEditable || !!target.closest('input, textarea, select, [contenteditable="true"], .ql-editor'));

/**
 * Cmd+Z (Ctrl+Z on Windows) takes back the newest change Undo keeps, a step further back each time, the same as the
 * calendar's Undo button. Nothing here reads the store, so nothing renders as changes come and go.
 */
const UndoShortcut = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (!(event.metaKey || event.ctrlKey) || event.shiftKey || event.altKey) return;
      // `code` too: on a non-Latin layout the key reports another letter.
      if (event.key.toLowerCase() !== 'z' && event.code !== 'KeyZ') return;
      if (event.repeat || isTyping(event.target)) return;
      event.preventDefault();
      dispatch(undoActions.undoLatest());
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [dispatch]);

  return null;
};

export default UndoShortcut;
